export const REQUEST_CHAT_SIDEBAR_WIDTH_KEY = 'request-chat-sidebar-width'

export const DEFAULT_CHAT_SIDEBAR_WIDTH = 420
export const MIN_CHAT_SIDEBAR_WIDTH = 280
export const MAX_CHAT_SIDEBAR_WIDTH = 720
export const CHAT_SIDEBAR_VIEWPORT_MARGIN = 24
